import { API_URL } from "../utils/constants";
import { axiosInstance } from "./httpClient";

const getToken = () => {
  return localStorage.getItem("token");
};

const getMerchantId = () => {
  return localStorage.getItem("id");
};

const getRole = () => {
  return localStorage.getItem("Role");
};

export const fetchBalance = async () => {
  const token = getToken();
  const merchantId = getMerchantId();
  const userRole = getRole();
  try {
    const role = await localStorage.getItem("Role");
    const endpoint =
      role === "partner"
        ? `${API_URL}/merchants/partners/balance`
        : `${API_URL}/teachers/balance`;

    const response = await axiosInstance.get(endpoint, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response?.data?.result?.balance;
  } catch (error) {
    throw error;
  }
};
